import { ref } from 'vue'
import { defineStore } from 'pinia'
import dayjs from 'dayjs'
import { useStorage } from '@vueuse/core'
import { isSdb } from '../composables/utils'

const STORE_KEY = 'protargeting-targeting-suggestion'

export const useTargetingSuggestionStore = defineStore(STORE_KEY, () => {
  const isOpen = ref(false)
  const isOpenDue = ref(false)
  const toolUsage = useStorage(`${STORE_KEY}-tool-usage`, 0)
  const lastRequest = useStorage(`${STORE_KEY}-last-request`, dayjs().subtract(1, 'd'))
  const prompt = ref(false)
  const targetingSuggestionElement = ref<HTMLElement>()

  function isDue(availableSuggestions: number) {
    if (toolUsage.value < 5) return false
    if (availableSuggestions <= 0) return false
    if (!isSdb()) return false

    const daysSinceLastRequest = dayjs().diff(lastRequest.value, 'day')
    return daysSinceLastRequest >= 1 && toolUsage.value % 5 === 0
  }

  function request(availableSuggestions: number) {
    if (isDue(availableSuggestions)) {
      targetingSuggestionElement.value = (document.querySelector('#targetingSuggestionElement') as any) ?? undefined

      prompt.value = true
      lastRequest.value = dayjs()
    } else {
      toolUsage.value += 1
    }
  }

  return { isOpen, isOpenDue, toolUsage, lastRequest, prompt, targetingSuggestionElement, request }
})
